import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
import AcceptedInvitation from '../../pages/AcceptedInvitation';
import Account from '../../pages/Account';
import AddSegment from '../../pages/AddSegment';
import AssetDetails from '../../pages/AssetDetails';
import Contacts from '../../pages/Contacts';
import CSVUpload from '../../pages/CSVUpload';
import CustomInsights from '../../pages/CustomInsights';
import CustomList from '../../pages/CustomList';
import CustomListDetails from '../../pages/CustomListDetails';
import Dashboard from '../../pages/Dashboard';
import Flows from '../../pages/Flows';
import CreateFlow from '../../pages/Flows/CreateFlow';
import FormCampaigns from '../../pages/FormCampaigns';
import Forms from '../../pages/Forms';
import CreateForm from '../../pages/Forms/CreateForm';
import FormsAnalytics from '../../pages/Forms/FormsAnalytics';
import GoogleCloudSignUp from '../../pages/GoogleCloudSignUp';
import Homepage from '../../pages/Homepage';
import MyTeam from '../../pages/MyTeam';
import NFTDetails from '../../pages/NFTDetails';
import NotFound from '../../pages/NotFound';
import ProfileDetails from '../../pages/ProfileDetails';
import RejectedInvitation from '../../pages/RejectedInvitation';
import SegmentDetails from '../../pages/SegmentDetails';
import Segments from '../../pages/Segments';
import Settings from '../../pages/Settings';
import WebSDK from '../../pages/WebSDK';
import { getUser } from '../../store/reducers/user';
import Wrapper from './Wrapper';

const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector(getUser);

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && location.pathname === '/') {
      const hasContactsPermission = !!user.contacts;

      if (hasContactsPermission) {
        const searchParams = new URLSearchParams({
          page: 1,
          limit: 10,
          orderBy: 'address',
          fields: 'address,lists,segments,email',
        });
        navigate(`/contacts?${searchParams.toString()}`, {
          replace: true,
        });
      } else {
        navigate('/dashboard', {
          replace: true,
        });
      }
    }
  }, [user, navigate, location.pathname]);

  return (
    <Routes>
      <Route path="/" element={<Wrapper />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="search" element={<Homepage />} />
        <Route path="coins/:name" element={<AssetDetails />} />
        <Route path="nfts/:network/:name" element={<NFTDetails />} />
        <Route path="profile/:name" element={<ProfileDetails />} />
        <Route path="my-team" element={<MyTeam />} />
        <Route path="audiences" element={<Segments />} />
        <Route path="segment/:id" element={<SegmentDetails />} />
        <Route path="add-segment" element={<AddSegment />} />
        <Route path="add-segment/:id" element={<AddSegment />} />
        <Route path="flows" element={<Flows />} />
        <Route path="forms" element={<Forms />} />
        <Route path="custom-insights" element={<CustomInsights />} />
        <Route path="add-custom-list" element={<CustomList />} />
        <Route path="csv-upload" element={<CSVUpload />} />
        <Route path="add-custom-list/:id" element={<CustomList />} />
        <Route path="custom-list/:id" element={<CustomListDetails />} />
        <Route path="add-flow" element={<CreateFlow />} />
        <Route path="add-flow/:flowId" element={<CreateFlow />} />
        <Route path="add-form" element={<CreateForm />} />
        <Route path="add-form/:formId" element={<CreateForm />} />
        <Route path="form-analytics/:formId" element={<FormsAnalytics />} />
        <Route path="tracked-website/:id" element={<WebSDK />} />
        <Route path="accepted" element={<AcceptedInvitation />} />
        <Route path="gcp-signup" element={<GoogleCloudSignUp />} />
        <Route path="rejected" element={<RejectedInvitation />} />
        <Route path="settings" element={<Settings />} />
        <Route path="account" element={<Account />} />
        <Route path="form/campaign" element={<FormCampaigns />} />
        <Route path="form/campaign/:id" element={<FormCampaigns />} />
        <Route path="contacts" element={<Contacts />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Layout;
